import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppModuloEmpComponent } from './app-modulo-emp.component';
import { FormsModule } from '@angular/forms';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxWindowModule } from 'jqwidgets-ng/jqxwindow';

@NgModule({
  declarations: [AppModuloEmpComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxWindowModule,
    jqxGridModule,
  ],
  exports: [AppModuloEmpComponent],
})
export class AppModuloEmpModule {}
